import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { GLOBAL_DATE_FORMAT } from 'common/dateFormatConfig';
import { parseStringDate } from 'helpers/_date-helpers';
import formatNumber from '../../utils/formatNumber';
import useTabs from '../../hooks/useTabs';
import PrintView from './PrintView';
import DayPrint from './DayPrint';
import { Field, WeekSummary } from './Rows';
import styles from './styles';

const useStyles = makeStyles(styles);

const DayListPrint = ({ weekHours }) => {
  const classes = useStyles();
  const { currentTab } = useTabs();
  const summary = useSelector((state) => state.timeclocks.summary);
  const orgName = useSelector((state) => state.personalProfile?.organization?.name || '');

  return (
    <PrintView
      header={
        <div className={classes.head}>
          <div className={classes.subject}>
            {format(parseStringDate(summary.query.date), GLOBAL_DATE_FORMAT.fullDateWithDay)}
          </div>
          <div>{currentTab.label}</div>
        </div>
      }
    >
      {summary.data.map((d) => (
        <DayPrint
          key={d.user._id}
          title={
            <>
              {d.user.profile?.fullName || d.user.username}
              <span>{d.user.profile && `#${d.user.profile.employeeNum}`}</span>
            </>
          }
          summary={d}
        />
      ))}
      {!summary.data.length && <div className={classes.item}>No work is done</div>}
      {weekHours && (
        <WeekSummary>
          <Field label={`${orgName} hours this week:`}>
            {formatNumber(weekHours.gmWeekHours)} hours
          </Field>
          <Field label="Machine shop hours this week:">
            {formatNumber(weekHours.msWeekHours)} hours
          </Field>
        </WeekSummary>
      )}
    </PrintView>
  );
};

export default DayListPrint;
